import { action } from 'typesafe-actions';
import type { ITemplateTag } from '../templateCreate/template-types';

export enum ActionTypes {
  RESET = 'templateTagging/RESET',
  FETCH_TAGS = 'templateTagging/FETCH_TAGS',
  FETCH_TAGS_DONE = 'templateTagging/FETCH_TAGS_DONE',
  CHANGE_TAG = 'templateTagging/CHANGE_TAG',
  CHANGE_NAME = 'templateTagging/CHANGE_NAME',
  SAVE = 'templateTagging/SAVE',
  SAVE_DONE = 'templateTagging/SAVE_DONE',
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const reset = () => action(ActionTypes.RESET);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTags = (templateId: string) => action(ActionTypes.FETCH_TAGS, templateId);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTagsDone = (name: string, tags: ITemplateTag[]) =>
  action(ActionTypes.FETCH_TAGS_DONE, { name, tags });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const changeTag = (tagTypeId: string, values: string[]) => action(ActionTypes.CHANGE_TAG, { tagTypeId, values });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const changeName = (name: string) => action(ActionTypes.CHANGE_NAME, name);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const save = (templateId: string) => action(ActionTypes.SAVE, templateId);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const saveDone = () => action(ActionTypes.SAVE_DONE);
